// ============================================================================
// TRADITIONAL CHINESE TRANSLATIONS - CHAPTER 7: 書信與啟示錄
// ============================================================================
// 關卡 79-91 (13 個關卡, 39 個問題)

export const chapter7Translations = {
  name: "書信與啟示錄",
  description: "得勝的必承受這些為業... 從上頭來的智慧使悟性成聖",
  
  spiritualWisdom: {
    principle: "從上頭來的智慧使悟性成聖,使靈魂復甦",
    scripture: "你們中間若有缺少智慧的,應當求那厚賜與眾人的神 (雅各書 1:5)",
    application: "每一封使徒書信和每一個啟示錄的異象都加深我們的理解,堅固我們的盼望"
  },
  
  levels: {
    79: {
      name: "在耶路撒冷被捕",
      challenge: "我不但被人捆綁,就是死在耶路撒冷也是願意的...",
      easy: {
        question: "保羅在最後一次旅行中於何處被捕?",
        options: ["安提阿", "以弗所", "耶路撒冷", "哥林多"],
        correctAnswer: 2,
        hint: "常常逼迫先知的聖城",
        funFact: "🏛️ 耶路撒冷:所有神的僕人榮耀與受難之地!"
      },
      medium: {
        question: "猶太人以什麼罪名控告保羅?",
        options: [
          "從聖殿偷竊",
          "帶外邦人進入聖殿玷污聖殿",
          "褻瀆摩西",
          "反叛羅馬"
        ],
        correctAnswer: 1,
        hint: "與福音的普世性有關的指控",
        funFact: "⛪ 諷刺:保羅被控玷污他深深尊重的聖殿!"
      },
      hard: {
        question: "保羅如何將監禁轉化為機會?",
        options: [
          "他逃跑了",
          "他在掌權者面前作見證並寫下書信",
          "他保持沉默",
          "他要求釋放"
        ],
        correctAnswer: 1,
        hint: "關於將試煉轉化為見證",
        funFact: "⛓️ 肉體的鎖鏈,靈性的自由 - 信仰的強大見證!"
      }
    },
    
    80: {
      name: "在巡撫腓力斯面前",
      challenge: "講論公義、節制和將來的審判時...",
      easy: {
        question: "保羅在哪位巡撫面前為信仰作見證?",
        options: ["彼拉多", "腓力斯", "非斯都", "迦流"],
        correctAnswer: 1,
        hint: "以貪婪聞名的巡撫",
        funFact: "⚖️ 腓力斯指望賄賂 - 公義面前的腐敗!"
      },
      medium: {
        question: "腓力斯對保羅的信息有何反應?",
        options: [
          "他悔改了",
          "他甚覺恐懼戰兢",
          "他嘲笑",
          "他漠不關心"
        ],
        correctAnswer: 1,
        hint: "被真理攪動的良心",
        funFact: "😰 即使腐敗者也在神的真理前戰兢 - 普世良知!"
      },
      hard: {
        question: "腓力斯為何將保羅監禁兩年?",
        options: [
          "為保護他",
          "出於政治考量和腐敗的期望",
          "他忘記了",
          "出於信仰"
        ],
        correctAnswer: 1,
        hint: "關於政治和個人盤算",
        funFact: "🏛️ 腐敗的人類正義 vs 完美的神的公義 - 巨大差異!"
      }
    },

    81: {
      name: "上訴於該撒",
      challenge: "我要上告於該撒!",
      easy: {
        question: "保羅運用什麼權利避免在耶路撒冷受審?",
        options: [
          "庇護權",
          "上訴於該撒(羅馬公民權)",
          "逃亡權",
          "外交保護"
        ],
        correctAnswer: 1,
        hint: "他羅馬公民身份的特權",
        funFact: "🏛️ 羅馬公民身份:將福音帶到羅馬的神聖通行證!"
      },
      medium: {
        question: "保羅在啟程前向誰作見證?",
        options: [
          "公會",
          "亞基帕王和百尼基",
          "羅馬士兵",
          "猶太人群眾"
        ],
        correctAnswer: 1,
        hint: "希律王朝的猶太化分支",
        funFact: "👑 從牧羊人到王宮 - 保羅神聖的提升!"
      },
      hard: {
        question: "神如何使用人類體系成就祂的計劃?",
        options: [
          "祂忽視它們",
          "祂主權地使用它們成就祂的旨意",
          "祂摧毀它們",
          "祂總是對抗它們"
        ],
        correctAnswer: 1,
        hint: "關於神對歷史的主權",
        funFact: "🌐 羅馬法律成為福音的工具 - 奇妙的護理!"
      }
    },

    82: {
      name: "在馬爾他海難",
      challenge: "不要害怕,保羅;你必站在該撒面前...",
      easy: {
        question: "保羅在哪個島嶼遭遇海難?",
        options: ["克里特", "塞浦路斯", "馬爾他", "西西里"],
        correctAnswer: 2,
        hint: "西西里南部的小島",
        funFact: "🏝️ 馬爾他:必經的停留變成豐碩的宣教 - 神的道路!"
      },
      medium: {
        question: "保羅在馬爾他行了什麼神蹟?",
        options: [
          "他平靜風暴",
          "他治癒了部百流的父親和其他病人",
          "他使食物增多",
          "他使死人復活"
        ],
        correctAnswer: 1,
        hint: "在島上眾多的醫治",
        funFact: "🏥 保羅:從海難受害者到神蹟醫治者 - 神聖榮耀!"
      },
      hard: {
        question: "這次海難如何顯明神的信實?",
        options: [
          "意外總會發生",
          "儘管有障礙,神保護並履行祂的應許",
          "保羅只是幸運",
          "這是可以避免的"
        ],
        correctAnswer: 1,
        hint: "關於神對應許的信實",
        funFact: "⛈️ 風暴、海難、蛇:沒有什麼能阻止神對保羅的計劃!"
      }
    },

    83: {
      name: "保羅在羅馬",
      challenge: "他在自己所租的房子裡住了足足兩年...",
      easy: {
        question: "保羅在羅馬以何種狀態生活?",
        options: [
          "在封閉的監獄中",
          "軟禁在家中",
          "完全自由",
          "流放中"
        ],
        correctAnswer: 1,
        hint: "在守衛下的相對自由",
        funFact: "🏠 家庭監獄成為宣教中心 - 鎖鏈中的自由!"
      },
      medium: {
        question: "保羅在羅馬的兩年裡做了什麼?",
        options: [
          "他休息",
          "他教導並寫下書信",
          "他準備辯護",
          "他旅行"
        ],
        correctAnswer: 1,
        hint: "儘管被鎖鏈捆綁仍密集服事",
        funFact: "✍️ 監獄書信:以弗所書、腓立比書、歌羅西書、腓利門書!"
      },
      hard: {
        question: "根據傳統,保羅如何結束事奉?",
        options: [
          "他病死",
          "在尼祿統治下約公元67年被斬首",
          "他老死",
          "他神秘消失"
        ],
        correctAnswer: 1,
        hint: "在瘋狂皇帝統治下殉道",
        funFact: "⚔️ '那美好的仗我已經打過了,當跑的路我已經跑盡了' - 最終勝利!"
      }
    },

    84: {
      name: "羅馬書",
      challenge: "我不以福音為恥;這福音本是神的大能,要救一切相信的...",
      easy: {
        question: "哪卷書信最詳細地發展因信稱義的教義?",
        options: ["哥林多前書", "加拉太書", "羅馬書", "以弗所書"],
        correctAnswer: 2,
        hint: "保羅的'神學大教堂'",
        funFact: "🏛️ 羅馬書:使奧古斯丁和路德歸信的神學傑作!"
      },
      medium: {
        question: "根據羅馬書,人如何在神面前稱義?",
        options: [
          "靠善行",
          "唯獨因信,不憑行為",
          "靠祭物",
          "靠傳統"
        ],
        correctAnswer: 1,
        hint: "宗教改革的基本原則",
        funFact: "⚖️ '義人必因信得生' - 保羅的屬靈革命!"
      },
      hard: {
        question: "這封書信有何普世規模?",
        options: [
          "只涉及羅馬人",
          "它闡述了全人類的救贖計劃",
          "它只批評羅馬",
          "它已過時"
        ],
        correctAnswer: 1,
        hint: "關於全球救贖計劃",
        funFact: "🌍 福音 = 神的大能,臨到所有人:猶太人和希臘人 - 完全普世性!"
      }
    },

    85: {
      name: "愛的頌歌 - 哥林多前書13章",
      challenge: "我若能說萬人的方言,並天使的話語,卻沒有愛...",
      easy: {
        question: "聖經哪一章被稱為'愛的頌歌'?",
        options: [
          "哥林多前書12章",
          "哥林多前書13章",
          "約翰一書4章",
          "羅馬書8章"
        ],
        correctAnswer: 1,
        hint: "哥林多前書的中心章節",
        funFact: "💝 婚禮上最常讀的章節 - 愛的完美定義!"
      },
      medium: {
        question: "保羅對愛的持久性說了什麼?",
        options: [
          "愛會隨時間消逝",
          "愛是永不止息",
          "愛取決於環境",
          "愛是暫時的"
        ],
        correctAnswer: 1,
        hint: "神的愛的永恆性",
        funFact: "♾️ 只有愛穿越死亡和永恆 - 最高價值!"
      },
      hard: {
        question: "保羅為何將愛置於屬靈恩賜之上?",
        options: [
          "恩賜是壞的",
          "愛賦予其他一切意義和價值",
          "愛更容易",
          "恩賜會分裂"
        ],
        correctAnswer: 1,
        hint: "關於所有服事的動力和意義",
        funFact: "🎯 沒有愛,即使最大的恩賜也變成噪音和驕傲!"
      }
    },

    86: {
      name: "以弗所書:教會是基督的身體",
      challenge: "又將萬有服在他的腳下,使他為教會作萬有之首...",
      easy: {
        question: "根據以弗所書,教會對基督而言是什麼?",
        options: [
          "祂的殿",
          "祂的身體",
          "祂的家庭",
          "祂的軍隊"
        ],
        correctAnswer: 1,
        hint: "合一的有機隱喻",
        funFact: "👤 基督的身體:每個基督徒都是重要肢體 - 互相依存!"
      },
      medium: {
        question: "保羅為屬靈爭戰描述了什麼軍裝?",
        options: [
          "物理武器",
          "神的全副軍裝:真理、公義、平安、信德、救恩、神的道",
          "羅馬武器",
          "魔法防禦"
        ],
        correctAnswer: 1,
        hint: "屬靈軍裝的六個部分",
        funFact: "⚔️ 屬靈爭戰用屬靈軍裝 - 神的得勝策略!"
      },
      hard: {
        question: "根據保羅,我們真正的爭戰是對抗什麼?",
        options: [
          "對抗惡人",
          "對抗屬靈的惡勢力",
          "對抗政府",
          "對抗貧窮"
        ],
        correctAnswer: 1,
        hint: "關於看不見的屬靈勢力",
        funFact: "👹 宇宙爭戰:在人類衝突背後,有真實的屬靈戰役!"
      }
    },

    87: {
      name: "腓立比書:患難中的喜樂",
      challenge: "你們要靠主常常喜樂;我再說,你們要喜樂!",
      easy: {
        question: "儘管身在監獄,保羅鼓勵什麼情感?",
        options: ["絕望", "喜樂", "憤怒", "悲傷"],
        correctAnswer: 1,
        hint: "囚犯的驚人情感",
        funFact: "😊 喜樂在4章中出現16次 - 監獄喜樂記錄!"
      },
      medium: {
        question: "根據腓立比書2章,耶穌採取了什麼姿態?",
        options: [
          "祂用力量強迫",
          "祂謙卑自己,存心順服,以至於死",
          "祂逃避責任",
          "祂尋求榮耀"
        ],
        correctAnswer: 1,
        hint: "自願的降卑之路",
        funFact: "📉 耶穌:從與神同等到十字架之死 - 顛倒的愛!"
      },
      hard: {
        question: "保羅如何能在監獄中傳講喜樂?",
        options: [
          "他在假裝",
          "基督徒的喜樂超越環境",
          "他是受虐狂",
          "他否認現實"
        ],
        correctAnswer: 1,
        hint: "關於超自然的喜樂",
        funFact: "✨ 喜樂 = 聖靈的果子,不論環境 - 神的秘訣!"
      }
    },

    88: {
      name: "教牧書信",
      challenge: "你要為真道打那美好的仗,持定永生...",
      easy: {
        question: "保羅將最後的教牧書信寫給了誰?",
        options: [
          "哥林多人",
          "提摩太和提多",
          "羅馬人",
          "加拉太人"
        ],
        correctAnswer: 1,
        hint: "他屬靈的兒子和同工",
        funFact: "👨‍👦 屬靈遺產:保羅將火炬傳給下一代!"
      },
      medium: {
        question: "保羅對選擇教會領袖給出什麼建議?",
        options: [
          "選擇最富有的",
          "按照嚴格的道德和屬靈標準選擇",
          "選擇最有學問的",
          "選擇最受歡迎的"
        ],
        correctAnswer: 1,
        hint: "道德品質優先",
        funFact: "⚖️ 領袖的高標準:品格先於能力 - 神的優先次序!"
      },
      hard: {
        question: "保羅留給提摩太什麼遺產?",
        options: [
          "物質財富",
          "對福音的忠誠和牧養事工",
          "政治職位",
          "神學院"
        ],
        correctAnswer: 1,
        hint: "關於屬靈遺產",
        funFact: "📜 '守住那美好的託付' - 福音世代相傳的忠心!"
      }
    },

    89: {
      name: "希伯來書:耶穌大祭司",
      challenge: "我們既然有一位已經升入高天尊榮的大祭司...",
      easy: {
        question: "根據希伯來書,誰是我們的大祭司?",
        options: ["亞倫", "摩西", "耶穌", "麥基洗德"],
        correctAnswer: 2,
        hint: "神與人之間的完美中保",
        funFact: "✝️ 耶穌:既是祭司又是祭物 - 一次永遠的完美祭!"
      },
      medium: {
        question: "為何耶穌的祭司職分優於亞倫的?",
        options: [
          "更古老",
          "照著麥基洗德的等次,永遠長存",
          "更富有",
          "更有名"
        ],
        correctAnswer: 1,
        hint: "永恆對暫時",
        funFact: "♾️ 永遠的祭司職分:耶穌永遠為我們代求!"
      },
      hard: {
        question: "希伯來書如何呈現新約?",
        options: [
          "與舊約相同",
          "更好且最終,寫在心上",
          "暫時的",
          "可選的"
        ],
        correctAnswer: 1,
        hint: "關於應驗和超越",
        funFact: "📋 新約:律法寫在心上,不是在石版上!"
      }
    },

    90: {
      name: "雅各書:信心與行為",
      challenge: "信心若沒有行為就是死的...",
      easy: {
        question: "根據雅各書,什麼應該伴隨信心?",
        options: [
          "話語",
          "行為",
          "感覺",
          "知識"
        ],
        correctAnswer: 1,
        hint: "信心的實際展示",
        funFact: "🌳 信心 = 根,行為 = 果 - 完整的屬靈樹!"
      },
      medium: {
        question: "雅各將舌頭比作什麼?",
        options: [
          "劍",
          "能點著大森林的小火",
          "樂器",
          "工具"
        ],
        correctAnswer: 1,
        hint: "小器官卻有巨大破壞力",
        funFact: "🔥 舌頭:小小肢體,卻能焚燒整個人生 - 警惕!"
      },
      hard: {
        question: "我們如何調和雅各和保羅關於信心/行為的教導?",
        options: [
          "他們矛盾",
          "保羅談稱義,雅各談成聖",
          "某人錯了",
          "沒有解決方案"
        ],
        correctAnswer: 1,
        hint: "關於兩個互補的方面",
        funFact: "⚖️ 保羅:因信得救 / 雅各:信心藉行為證明 - 完美和諧!"
      }
    },

    91: {
      name: "啟示錄:王的再來",
      challenge: "看哪,我必快來。凡遵守這書上預言的有福了!",
      easy: {
        question: "約翰在啟示錄中寫信給幾個教會?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "完全的數字",
        funFact: "⛪ 亞細亞的七個教會:所有時代所有教會的鏡子!"
      },
      medium: {
        question: "根據啟示錄,歷史如何結束?",
        options: [
          "完全毀滅",
          "新天新地",
          "回到地上樂園",
          "一切存在的終結"
        ],
        correctAnswer: 1,
        hint: "創造的完全更新",
        funFact: "🌅 不是世界末日,而是完全更新 - 終極盼望!"
      },
      hard: {
        question: "啟示錄向受逼迫者傳遞什麼核心信息?",
        options: [
          "投降吧",
          "基督掌權,最終必得勝",
          "逃離逼迫",
          "報復"
        ],
        correctAnswer: 1,
        hint: "關於最終勝利的盼望",
        funFact: "👑 '昔在、今在、以後永在的' - 歷史和時間的主!"
      }
    }
  }
};

export default chapter7Translations;
